import React, { useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import { ArrowDropDown } from '@material-ui/icons';
import { FlexRowDiv, DropdownMenu, Dropdown, DropdownContent, MenuContainer } from './menuStyle';
import { AppContext } from '../../context/appContext';
import { ServerUrl, GetCurrentYear } from '../../constants';
import axios from 'axios';

const NavbarMenuComponent = (props) => {
  const { CurrentUser, QuickSightUrl } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const { menu, index } = props;
  const [ showDropdown, setShowDropdown ] = useState('hidden');

  if (menu.name === "Data Lookup") {
    if (!CurrentUser || !QuickSightUrl) return null;
  }

  if (menu.name === "Admin Export" && CurrentUser.role !== "admin") {
    return null;
  }

  const ExportAll = () => {
    const currentYear = GetCurrentYear() - 2000;
    let current_year = currentYear + '-' + (currentYear + 1);
    let previous_year = (currentYear - 1) + '-' + currentYear;

    axios.get(`${ServerUrl}/annually/all/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','AllIndicators.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  return (
    <Dropdown key={index} onMouseEnter={() => {setShowDropdown('visible')}} onMouseLeave={() => {setShowDropdown('hidden')}}>
      <FlexRowDiv onClick={() => { 
          if (menu.name === "Data Lookup") {
              window.open(QuickSightUrl, "_blank");
          } else if (menu.name === "Export All") {
            ExportAll();
          } else {
            props.history.push(menu.link)
          }
        }} >
        {menu.name} 
        {menu.submenus && <ArrowDropDown fontSize="small" />}
      </FlexRowDiv>
      {menu.submenus && 
        <DropdownContent style={{visibility: showDropdown}}>
          <MenuContainer>
            {menu.submenus && menu.submenus.map((submenu, subIndex) => {
              return ( 
                <DropdownMenu key={`${index}-${subIndex}`} onClick={() => {
                  setShowDropdown('hidden');
                  props.history.push(submenu.link);
                  }}>
                  <span>{submenu.name}</span>
                </DropdownMenu>
              )})
            }
          </MenuContainer>
        </DropdownContent>
      }
    </Dropdown>
  )
}

export default withRouter(NavbarMenuComponent);

